"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rotaryBackgroundAlignments = exports.rotaryBackgroundStyles = exports.backgroundUtils = void 0;
exports.backgroundUtils = {
    getBackgroundStyleByName: function (searchName) {
        return exports.rotaryBackgroundStyles.find(function (element) { return element.name == searchName; }) || null;
    },
    getBackgroundAlignmentByName: function (searchName) {
        return exports.rotaryBackgroundAlignments.find(function (element) { return element.name == searchName; }) || null;
    },
    getBackgroundStyles: function () {
        return exports.rotaryBackgroundStyles;
    },
    getBackgroundAlignments: function () {
        return exports.rotaryBackgroundAlignments;
    }
};
exports.rotaryBackgroundStyles = [
    {
        name: 'default',
        invertText: false,
    },
    {
        name: 'white',
        invertText: false,
    },
    {
        name: 'gray',
        invertText: false,
    },
    {
        name: 'gray-textured',
        invertText: false,
    },
    {
        name: 'red',
        invertText: true,
    },
    {
        name: 'red-textured',
        invertText: true,
    },
    {
        name: 'green',
        invertText: true,
    },
    {
        name: 'green-textured',
        invertText: true,
    },
    {
        name: 'darkblue',
        invertText: true,
    },
    {
        name: 'darkblue-textured',
        invertText: true,
    },
    {
        name: 'brightblue',
        invertText: true,
    },
    {
        name: 'brightblue-textured',
        invertText: true,
    },
    {
        name: 'gold',
        invertText: true,
    },
    // There is no gold-textured
    {
        name: 'purple',
        invertText: true,
    },
    {
        name: 'purple-textured',
        invertText: true,
    }
];
exports.rotaryBackgroundAlignments = [
    {
        name: 'center'
    },
    {
        name: 'left'
    },
    {
        name: 'right'
    }
];
//# sourceMappingURL=backgrounds.js.map